"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const reactstrap_1 = require("reactstrap");
const AccessKey_1 = require("./AccessKey");
class IntegrationAccessKey extends react_1.default.Component {
    render() {
        return this.props.integration.accessKey ? (react_1.default.createElement(AccessKey_1.AccessKey, { accessKey: this.props.integration.accessKey, onDelete: this.props.onDelete, onArchive: this.props.onArchive })) : (react_1.default.createElement(reactstrap_1.Button, { color: "primary", className: "w-100", href: `/api/v1/auth/redirect?callback=${encodeURIComponent(window.location.pathname)}&integrationId=${this.props.integration.id}&integrationType=${this.props.integration.integrationType}`, target: "_blank", tag: "a" },
            "Authenticate with ",
            this.props.integration.displayType));
    }
}
exports.IntegrationAccessKey = IntegrationAccessKey;
//# sourceMappingURL=IntegrationAccessKey.js.map